@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.onboarding {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  &Box {
    background-color: map.get(core.$colors, lightGrey);
    border-radius: 8px;
    color: map.get(core.$colors, darkBlue);
    width: max-content;
    padding: 40px;
  }
}
